/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./case-practice-messagebox.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./case-practice-messagebox.component";
var styles_CasePracticeMessageboxComponent = [i0.styles];
var RenderType_CasePracticeMessageboxComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CasePracticeMessageboxComponent, data: {} });
export { RenderType_CasePracticeMessageboxComponent as RenderType_CasePracticeMessageboxComponent };
export function View_CasePracticeMessageboxComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵted(-1, null, ["\n"]))], null, null); }
export function View_CasePracticeMessageboxComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-case-practice-message-box", [], null, null, null, View_CasePracticeMessageboxComponent_0, RenderType_CasePracticeMessageboxComponent)), i1.ɵdid(1, 114688, null, 0, i2.CasePracticeMessageboxComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CasePracticeMessageboxComponentNgFactory = i1.ɵccf("app-case-practice-message-box", i2.CasePracticeMessageboxComponent, View_CasePracticeMessageboxComponent_Host_0, {}, {}, []);
export { CasePracticeMessageboxComponentNgFactory as CasePracticeMessageboxComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/case-practice-hotel-component/case-practice-messagebox.component.ngfactory.js.pre-build-optimizer.js